import apiUrl from '../../Shared/ApiUrl'
import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Switch, Card, Box, CardContent, CardActions, TextField, Grid, FormGroup, FormControlLabel, Checkbox, FormControl, FormHelperText, InputLabel, FilledInput, InputAdornment, IconButton, Typography, Container, OutlinedInput, Paper, CircularProgress } from '@mui/material'
import { circularProgressClasses } from '@mui/material/CircularProgress'
import { useTheme } from '@mui/material/styles';
import "./registerClient.css"

//import { useNavigate } from "react-router-dom";

import { useToast } from '../../Shared/Toast/ToastContext';
import { Visibility, VisibilityOff, Key, AccountCircle, Factory, Groups, Person, Phone } from '@mui/icons-material'

import '../GuiasAdmin/Shipping/shippingStyles.css'

const RegisterClient = () => {
    const navigate = useNavigate();
    const [prefersDarkMode, setPrefersDarkMode] = useState(false)
    const { showToast } = useToast();
    const [form, setForm] = useState({
        commercialName: "",
        socialReason: "",
        name: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
    })
    const [isCompany, setIsCompany] = useState(false)
    const [isShowingCompany, setIsShowingCompany] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [waitAnResult, setWaitAnResult] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState({
        commercialName: {
            status: false,
            message: '',
            touched: false,
        },
        socialReason: {
            status: false,
            message: '',
            touched: false,
        },
        name: {
            status: false,
            message: '',
            touched: false,
        },
        email: {
            status: false,
            message: '',
            touched: false,
        },
        phone: {
            status: false,
            message: '',
            touched: false,
        },
        password: {
            status: false,
            message: '',
            touched: false,
        },
        confirmPassword: {
            status: false,
            message: '',
            touched: false,
        },
    })

    const formRef = useRef(null);

    useEffect(() => {
        let newErrors = {};
        for (let key in form) {
            const input = formRef.current.elements[key];
            const isValid = isInputValid(input);

            newErrors[key] = {
                ...errors[key],
                status: isValid,
                message: errors[key].touched && !isValid ? errorMessages[key] : ''
            }
        }
        setErrors(newErrors);
    }, [form])

    useEffect(() => {
        setIsShowingCompany(isCompany)
    }, [isCompany])

    const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phonePattern = /^\d{10}$/;

    const errorMessages = {
        commercialName: 'El nombre comercial es obligatorio',
        socialReason: 'La razon social es obligatoria',
        name: 'El nombre es obligatorio',
        email: 'El correo electronico es obligatorio y debe ser un correo valido',
        phone: 'El telefono es obligatorio y deben ser solo 10 digitos',
        password: 'La contraseña es obligatoria y debe contener por lo menos 8 caracteres',
        confirmPassword: 'Las contraseñas no coinciden',
    }




    const handleClickShowPassword = () => setShowPassword(!showPassword)
    const handleMouseDownPassword = event => event.preventDefault()

    const handleChange = (e) => {

        setForm({
            ...form,
            [e.target.name]: e.target.value
        });

    };

    const handleBlur = (e) => {
        const input = e.target;
        const key = input.name;
        const isValid = isInputValid(input);
        console.log(input, key, isValid);
        setErrors({
            ...errors,
            [key]: {
                touched: true,
                status: isValid,
                message: !isValid ? errorMessages[key] : ''
            }
        });
    }

    const isInputValid = (input) => {
        switch (input.name) {
            case 'confirmPassword':
                return form.password === form.confirmPassword;
            case 'email':
                return input.checkValidity() && !!input.value.match(emailPattern)
            case 'phone':
                return input.checkValidity() && !!input.value.match(phonePattern)
            default:
                return input.checkValidity()
        }
    }

    const isFormValid = () => {
        let isValid = true;
        for (let key in form) {
            isValid = isValid && isInputValid(formRef.current.elements[key]);
        }
        return isValid;
    }

    const theme = useTheme();

    const envConfig = {
        url:apiUrl(),
        image: process.env.REACT_APP_IMAGE_LOGIN ? require(process.env.REACT_APP_IMAGE_LOGIN) : ''
    }

    const registerClient = async (event) => {
        if (!isFormValid()) return showToast("Revise todos los campos", "warning")
        setWaitAnResult(true)
        setLoading(true)
        event.preventDefault();

        let sentForm = { ...form };
        if (!isCompany) {
            sentForm = {
                ...sentForm,
                commercialName: form.name,
                socialReason: form.name
            }
        }

        await fetch(`${envConfig.url}/api/auth/registerClient`, {
            method: 'POST',
            headers: {
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sentForm)
        })
            .then(res => res.json())
            .then(data => {
                switch (data.status) {
                    case 200:
                        showToast("Sigue las instrucciones de tu correo para activar tu cuenta", "success");
                        navigate('/');
                        break;
                    case 409:
                        showToast(data.message, "warning");
                        setWaitAnResult(false);
                        setLoading(false);
                        break;
                    default:
                        showToast("Error al crear el usuario", "error");
                        setWaitAnResult(false)
                        setLoading(false)
                }
            })
    }

    const buttonCSS = {
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    };

    const textFieldCSS = {
        backgroundColor: '#ffffff',
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px',
        width: '97%',
        marginTop: '12px',
        marginBottom: '-27px'
    }

    return (
        <Container
            maxWidth='md'
            sx={{
                marginTop: '150px'
            }}
        >

            <Box
                sx={{
                    width: '275px',
                    height: '115px',
                    borderRadius: '1px'
                }}
                component="img"
                src={envConfig.image}
                alt="Login"
            />
            <Paper
                elevation={3}
                sx={{ marginY: 3, paddingX: 5, paddingY: 5 }}
            >
                <form onSubmit={registerClient} ref={formRef}>
                    <Container sx={{ textAlign: 'center' }}>
                        <Grid
                            container
                            spacing={5}
                        >


                            <Grid
                                item
                                sm={12}>
                                Datos personales
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={12}
                            >
                                <TextField
                                    error={errors.name.status}
                                    required
                                    id='outlined-text'
                                    label='Nombre completo'
                                    variant='outlined'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={form.name}
                                    name="name"
                                    helperText={errors.name.message}
                                    InputProps={{
                                        maxLength: 50,
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Person sx={{ color: theme.palette.primary.main }} />
                                            </InputAdornment>
                                        )
                                    }}
                                    fullWidth={true}
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={12}
                            >
                                <TextField
                                    error={errors.email.status}
                                    pattern={emailPattern}
                                    required
                                    id='outlined-text'
                                    label='Correo electronico'
                                    variant='outlined'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={form.email}
                                    name="email"
                                    helperText={errors.email.message}
                                    InputProps={{
                                        maxLength: 100,
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <AccountCircle sx={{ color: theme.palette.primary.main }} />
                                            </InputAdornment>
                                        )
                                    }}
                                    fullWidth={true}
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={12}
                            >
                                <TextField
                                    error={errors.phone.status}
                                    pattern={phonePattern}
                                    required
                                    id='outlined-text'
                                    label='Telefono'
                                    variant='outlined'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={form.phone}
                                    name="phone"
                                    helperText={errors.phone.message}
                                    inputProps={{ maxLength: 10 }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Phone sx={{ color: theme.palette.primary.main }} />
                                            </InputAdornment>
                                        )
                                    }}
                                    fullWidth={true}
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={12}
                            >
                                <FormControl
                                    error={errors.password.status}
                                    variant='outlined'
                                    fullWidth={true}
                                >
                                    <InputLabel htmlFor='outlined-adornment-password'>Contraseña</InputLabel>
                                    <OutlinedInput
                                        id='outlined-adornment-password'
                                        type={showPassword ? 'text' : 'password'}
                                        value={form.password}
                                        name="password"
                                        required
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        inputProps={{ maxLength: 15 }}
                                        startAdornment={
                                            <InputAdornment position='start'>
                                                <Key sx={{ color: theme.palette.primary.main }} />
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position='end'>
                                                <IconButton
                                                    aria-label='toggle password visibility'
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge='end'
                                                >
                                                    {showPassword ? <VisibilityOff sx={{ color: theme.palette.secondary.main }} /> : <Visibility sx={{ color: theme.palette.primary.main }} />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label='Contraseña'
                                    />
                                    <FormHelperText>{errors.password.message}</FormHelperText>
                                </FormControl>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={12}
                            >
                                <FormControl
                                    error={errors.confirmPassword.status}
                                    variant='outlined'
                                    fullWidth={true}
                                >
                                    <InputLabel htmlFor='outlined-adornment-confirm-password'>Confirmar contraseña</InputLabel>
                                    <OutlinedInput
                                        id='outlined-adornment-confirm-password'
                                        type={showPassword ? 'text' : 'password'}
                                        value={form.confirmPassword}
                                        name="confirmPassword"
                                        required
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        inputProps={{ maxLength: 15 }}
                                        startAdornment={
                                            <InputAdornment position='start'>
                                                <Key sx={{ color: theme.palette.primary.main }} />
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position='end'>
                                                <IconButton
                                                    aria-label='toggle password visibility'
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge='end'
                                                >
                                                    {showPassword ? <VisibilityOff sx={{ color: theme.palette.secondary.main }} /> : <Visibility sx={{ color: theme.palette.primary.main }} />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        label='Contraseña'
                                    />
                                    <FormHelperText>{errors.confirmPassword.message}</FormHelperText>
                                </FormControl>
                            </Grid>




                            <Grid
                                item
                                sm={12}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            inputProps={{ 'name': 'isCompany' }}
                                            checked={isCompany}
                                            onChange={(e) => {
                                                setIsCompany(e.target.checked)
                                            }} />
                                    }
                                    label="Cuenta Empresarial" />
                            </Grid>



                            <Grid
                                className={isShowingCompany ? '' : 'hidden'}
                                item
                                sm={12}>
                                Datos de la empresa
                            </Grid>

                            <Grid
                                className={isShowingCompany ? '' : 'hidden'}
                                item
                                xs={12}
                                md={12}
                            >
                                <TextField
                                    error={errors.commercialName.status}
                                    required={isShowingCompany ? true : undefined}
                                    id='outlined-text'
                                    label='Nombre comercial'
                                    variant='outlined'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={form.commercialName}
                                    name="commercialName"
                                    helperText={errors.commercialName.message}
                                    InputProps={{
                                        inputProps: { maxLength: 50 },
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Factory sx={{ color: theme.palette.primary.main }} />
                                            </InputAdornment>
                                        )
                                    }}
                                    fullWidth={true}
                                />
                            </Grid>

                            <Grid
                                className={isShowingCompany ? '' : 'hidden'}
                                item
                                xs={12}
                                md={12}
                            >
                                <TextField
                                    error={errors.socialReason.status}
                                    required={isShowingCompany ? true : undefined}
                                    id='outlined-text'
                                    label='Razon social'
                                    variant='outlined'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={form.socialReason}
                                    name="socialReason"
                                    helperText={errors.socialReason.message}
                                    InputProps={{
                                        inputProps: { maxLength: 50 },
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Groups sx={{ color: theme.palette.primary.main }} />
                                            </InputAdornment>
                                        )
                                    }}
                                    fullWidth={true}
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={5}
                            >
                                <div align='left'>
                                    <Button
                                        variant='contained'
                                        sx={buttonCSS}
                                        type='submit'
                                        disabled={waitAnResult}
                                    >
                                        Registrar
                                    </Button>
                                </div>
                            </Grid>


                            <Grid
                                item
                                xs={12}
                                md={7}
                            >
                                {loading ? (
                                    <>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            <Box>
                                                <CircularProgress
                                                    variant='indeterminate'
                                                    disableShrink
                                                    size={40}
                                                    sx={{
                                                        color: theme.palette.primary.main,
                                                        animationDuration: '550ms',
                                                        [`& .${circularProgressClasses.circle}`]: {
                                                            strokeLinecap: 'round'
                                                        }
                                                    }}
                                                />
                                            </Box>
                                            <Typography
                                                variant='body2'
                                                fontWeight='bold'
                                            >
                                                Procesando, espere un momento...
                                            </Typography>
                                        </div>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </Grid>
                        </Grid>
                    </Container>
                </form>
            </Paper>
        </Container>
    )
}

export default RegisterClient;